import { render, staticRenderFns } from "./EvidencesControl.vue?vue&type=template&id=aa175036&"
import script from "./EvidencesControl.vue?vue&type=script&lang=js&"
export * from "./EvidencesControl.vue?vue&type=script&lang=js&"
import style0 from "./EvidencesControl.vue?vue&type=style&index=0&id=aa175036&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports